export default __webpack_public_path__ + "static/media/mastercard.c5dbf442.webp";